<div class="fuel-quota-panel" *ngIf="currentStep !== 'confirmation'">
  <div class="container">

    <!-- Initial Loading Skeleton -->
    <div class="initial-loading-skeleton" *ngIf="isInitialLoading && !loadingErrorOccurred">
      <div class="loading-header">
        <ngx-skeleton-loader
          count="1"
          [theme]="{
            height: '60px',
            width: '100%',
            'border-radius': '0.75rem',
            'margin-bottom': '1.5rem'
          }"
        ></ngx-skeleton-loader>
      </div>

      <div class="loading-fleet-card">
        <ngx-skeleton-loader
          count="1"
          [theme]="{
            height: '120px',
            width: '100%',
            'border-radius': '0.5rem',
            'margin-bottom': '1rem'
          }"
        ></ngx-skeleton-loader>
      </div>

      <div class="loading-subfleet-cards">
        <ngx-skeleton-loader
          count="3"
          [theme]="{
            height: '80px',
            width: '100%',
            'border-radius': '0.5rem',
            'margin-bottom': '0.75rem'
          }"
        ></ngx-skeleton-loader>
      </div>
    </div>

    <!-- Error Empty State -->
    <div class="error-empty-state" *ngIf="loadingErrorOccurred && !isInitialLoading">
      <div class="error-empty-content">
        <div class="error-empty-icon">
          <mat-icon>error_outline</mat-icon>
        </div>
        <h2 class="error-empty-title">{{ errorMessage }}</h2>
        <p class="error-empty-description">{{ errorDetails }}</p>
        <div class="error-empty-actions">
          <button
            mat-raised-button
            color="primary"
            (click)="retryLoadData()"
            class="retry-button">
            <mat-icon>refresh</mat-icon>
            Tentar Novamente
          </button>
        </div>
      </div>
    </div>

    <!-- Page Header -->
    <div class="page-header d-none">
      <div class="header-content d-none">
        <div class="header-main">
          <div class="header-icon">
            <mat-icon>local_gas_station</mat-icon>
          </div>
          <div class="header-text">
            <h1 class="header-title">
              Controle de Cota Normalizada e Centralizada
            </h1>
            <p class="header-subtitle">
              Gerencie cotas de combustível e ajustes por frota
            </p>
          </div>
        </div>
      </div>

      <!-- Info Banner -->
      <div class="info-banner d-none">
        <mat-icon class="info-icon">info</mat-icon>
        <span class="info-text">
          <strong>Informação:</strong> Veículos com linha cinza estão
          desvinculados e não podem receber ajustes.
        </span>
      </div>
    </div>

    <!-- Fleet Sections -->
    <div class="fleet-sections" *ngIf="currentStep === 'adjustments' && !isInitialLoading && !loadingErrorOccurred">
        <!-- Macro Title -->
        <div class="macro-title" *ngFor="let macro of macroData">
          <div class="macro-header">
            <div class="macro-header-content">
              <div class="macro-title-section">
                <h2 class="macro-title-text">{{ macro.description }}</h2>
                <div class="macro-info">
                  <span class="macro-code">Código: {{ macro.code }}</span>
                  <span class="macro-date" *ngIf="!deveOcultarSaldoMacro(macro)"
                    >Último Ajuste: {{ macro.lastAdjustment }}</span
                  >
                  <span class="macro-balance" *ngIf="!deveOcultarSaldoMacro(macro)"
                    >Saldo: {{ macro.currentBalance }}</span
                  >
                  <span class="macro-quota" *ngIf="!deveOcultarSaldoMacro(macro)"
                    >Última Cota: {{ macro.lastQuota }}</span
                  >
                </div>
              </div>
              
            </div>
          </div>

        <!-- Search Input for Frotas -->
        <div class="search-section" *ngIf="shouldShowFleetSearch(macro)">
          <mat-form-field appearance="outline" class="search-field">
            <mat-label>Pesquisar Frota</mat-label>
            <input
              matInput
              [(ngModel)]="fleetSearchTerm[macro.id]"
              placeholder="Buscar por código ou descrição..."
              (click)="$event.stopPropagation()"
            />
            <mat-icon matPrefix>search</mat-icon>
          </mat-form-field>
        </div>

        <!-- Fleet Cards -->
        <div class="fleet-accordion">
          <div class="fleet-card" *ngFor="let fleet of getFilteredFleets(macro)">
            <div class="card-header" (click)="toggleFleet(fleet.id)">
              <div class="card-header-content">
                <div class="card-info">
                  <mat-icon
                    class="chevron-icon"
                    [class.expanded]="isFleetExpanded(fleet.id)"
                  >
                    {{
                      isFleetExpanded(fleet.id)
                        ? "keyboard_arrow_down"
                        : "keyboard_arrow_right"
                    }}
                  </mat-icon>
                 
                  <div class="card-details">
                    <h3 class="card-title">
                      Cód: <b class="bold-frota">{{fleet.codFrota}}</b>
                      | {{ fleet.description }}
                    </h3>
                  </div>
                </div>
                <div class="card-data">
                  <div class="data-item">
                    <span class="data-label">Último Ajuste</span>
                    <span class="data-value date">{{
                      fleet.lastAdjustment
                    }}</span>
                  </div>
                  <div class="data-item" *ngIf="!deveOcultarAjusteFrota(fleet)">
                    <span class="data-label">Última Cota</span>
                    <span class="data-value date" [ngClass]="{'negative-value': isNegativeValue(fleet.lastQuota)}">{{ fleet.lastQuota }}</span>
                  </div>
                  <div class="data-item" *ngIf="!deveOcultarSaldoFrota(fleet)">
                    <span class="data-label">Saldo</span>
                    <span class="data-value date" [ngClass]="{'negative-value': isNegativeBalance(fleet.currentBalance)}">
                      {{
                        fleet.currentBalance === "NaN" ||
                        fleet.currentBalance === "NaN"
                          ? 
                            originalFleetBalance.toLocaleString("pt-BR", {
                              minimumFractionDigits: 2
                            })
                          :  fleet.currentBalance
                      }}
                    </span>
                  </div>
                  <div class="adjustment-item" *ngIf="!deveOcultarAjusteFrota(fleet)">
                    <span class="data-label">Ajuste</span>
                    <mat-form-field
                      appearance="outline"
                      class="compact-field"
                    >
                      <input
                        matInput
                        type="text"
                        [(ngModel)]="adjustments['fleet-' + fleet.id]"
                        (ngModelChange)="onAdjustmentChange('fleet-' + fleet.id, $event)"
                        (blur)="onAdjustmentBlur('fleet-' + fleet.id, $any($event.target).value)"
                        (click)="$event.stopPropagation()"
                        name=""
                        required
                        mask="separator.2"
                        thousandSeparator="."
                        decimalMarker=","
                        prefix=""
                        [allowNegativeNumbers]="true"
                        [clearIfNotMatch]="false"
                        placeholder="0,00"
                        [disabled]="deveDesabilitarAjusteFrota(fleet)"
                      />
                    </mat-form-field>
                  </div>
                  <div class="adjustment-item" *ngIf="!deveOcultarAjusteFrota(fleet)">
                    <span class="data-label">Observação</span>
                    <mat-form-field
                      appearance="outline"
                      class="compact-field notes-field"
                    >
                      <input
                        matInput
                        type="text"
                        [(ngModel)]="notes['fleet-' + fleet.id]"
                        (click)="$event.stopPropagation()"
                        placeholder="Observação"
                        [disabled]="deveDesabilitarAjusteFrota(fleet)"
                      />
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>

            <div class="card-content" *ngIf="isFleetExpanded(fleet.id)">
              <!-- Sub-Fleet Cards -->
              <div class="subfleet-sections">
                <h4 class="section-title">Subfrotas</h4>

                <!-- Search Input for Subfrotas -->
                <div class="search-section" *ngIf="shouldShowSubFleetSearch(fleet)">
                  <mat-form-field appearance="outline" class="search-field">
                    <mat-label>Pesquisar Subfrota</mat-label>
                    <input
                      matInput
                      [(ngModel)]="subFleetSearchTerm[fleet.id]"
                      placeholder="Buscar por código ou descrição..."
                      (click)="$event.stopPropagation()"
                    />
                    <mat-icon matPrefix>search</mat-icon>
                  </mat-form-field>
                </div>

                <!-- Error Section -->
                <div class="error-section" *ngIf="hasError">
                  <div class="error-card">
                    <div class="error-content">
                      <div class="error-icon-text">
                        <mat-icon class="error-icon">warning</mat-icon>
                        <div class="error-text">
                          <h3 class="error-title">{{ errorMessage }}</h3>
                          <p class="error-details" *ngIf="errorDetails">{{ errorDetails }}</p>
                        </div>
                      </div>
                      <div class="error-actions">
                        <button 
                          mat-button 
                          color="primary" 
                          (click)="retryLoadData()"
                          class="retry-button">
                          <mat-icon>refresh</mat-icon>
                          Tentar Novamente
                        </button>
                        <button 
                          mat-button 
                          (click)="goToOldScreen()"
                          class="old-screen-button">
                          <mat-icon>arrow_back</mat-icon>
                          Tela Anterior
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Skeleton para carregamento inicial -->
                <div
                  *ngIf="
                    fleet.subFleets.length === 0 &&
                    !isLoadingSubFrotas(fleet.id) &&
                    !hasError &&
                    !subFrotaEmpty[fleet.id]
                  "
                  class="skeleton-loading"
                >
                  <div
                    class="subfleet-skeleton"
                    *ngFor="let item of [1, 2, 3, 4, 5]"
                  >
                    <div class="skeleton-header">
                      <ngx-skeleton-loader
                        count="1"
                        appearance="circle"
                        [theme]="{
                          height: '16px',
                          width: '16px',
                          'margin-right': '8px'
                        }"
                      ></ngx-skeleton-loader>
                      <ngx-skeleton-loader
                        count="1"
                        [theme]="{ height: '16px', width: '200px' }"
                      ></ngx-skeleton-loader>
                    </div>
                    <div class="skeleton-content">
                      <ngx-skeleton-loader
                        count="1"
                        [theme]="{
                          height: '12px',
                          width: '120px',
                          'margin-bottom': '6px'
                        }"
                      ></ngx-skeleton-loader>
                      <ngx-skeleton-loader
                        count="1"
                        [theme]="{ height: '12px', width: '80px' }"
                      ></ngx-skeleton-loader>
                    </div>
                  </div>
                </div>

                <!-- Mensagem quando não há subfrotas -->
                <div
                  *ngIf="subFrotaEmpty[fleet.id] && fleet.subFleets.length === 0"
                  class="empty-message"
                >
                  <mat-icon>info_outline</mat-icon>
                  <span>Não há subfrotas para exibir.</span>
                </div>

                <div
                  class="subfleet-card"
                  *ngFor="let subFleet of getFilteredSubFleets(fleet)"
                >
                  <div
                    class="card-header"
                    (click)="toggleSubFleet(subFleet.id)"
                  >
                    <div class="card-header-content">
                      <div class="card-info">
                        <mat-icon
                          class="chevron-icon"
                          [class.expanded]="isSubFleetExpanded(subFleet.id)"
                        >
                          {{
                            isSubFleetExpanded(subFleet.id)
                              ? "keyboard_arrow_down"
                              : "keyboard_arrow_right"
                          }}
                        </mat-icon>
                        <div class="card-details">
                          <h5 class="card-title">

                          <h5 class="card-title">
                            Cód:  <b class="bold-subfrota">{{subFleet.codSubFrota}} </b>
                           
                          </h5>
                          |  {{ subFleet.description }} 
                            
                            <ng-container *ngIf="shouldShowVehicles(subFleet.id)">
                            - <mat-icon> directions_car</mat-icon> ({{
                                subFleet.qtdVehicles
                              }})
                            </ng-container>
                          
                          </h5>
                        </div>
                      </div>
                      <div class="card-data">
                        <div class="data-item">
                          <span class="data-label">Último Ajuste</span>
                          <span class="data-value date">{{
                            subFleet.lastAdjustment
                          }}</span>
                        </div>
                        <div class="data-item" *ngIf="!deveOcultarAjusteSubFrota(subFleet)">
                          <span class="data-label">Última Cota</span>
                          <span class="data-value date" [ngClass]="{'negative-value': isNegativeValue(subFleet.lastQuota)}">{{
                            subFleet.lastQuota
                          }}</span>
                        </div>
                        <div class="data-item" *ngIf="!deveOcultarSaldoSubFrota(subFleet)">
                          <span class="data-label">Saldo</span>
                          <span class="data-value date" [ngClass]="{'negative-value': isNegativeBalance(subFleet.currentBalance)}">
                            {{
                              subFleet.currentBalance === "NaN" ||
                              subFleet.currentBalance === "NaN"
                                ?
                                  getOriginalSubFleetBalance(
                                    subFleet.id
                                  ).toLocaleString("pt-BR", {
                                    minimumFractionDigits: 2
                                  })
                                : subFleet.currentBalance
                            }}
                          </span>
                        </div>
                        <div class="adjustment-item" *ngIf="!deveOcultarAjusteSubFrota(subFleet)">
                          <span class="data-label">Ajuste</span>
                          <mat-form-field
                            appearance="outline"
                            class="compact-field"
                          >
                            <input
                              matInput
                              type="text"
                              [(ngModel)]="
                                adjustments['subfleet-' + subFleet.id]
                              "
                              (ngModelChange)="
                                onAdjustmentChange(
                                  'subfleet-' + subFleet.id,
                                  $event
                                )
                              "
                              (blur)="
                                onAdjustmentBlur(
                                  'subfleet-' + subFleet.id,
                                  $any($event.target).value
                                )
                              "
                              (click)="$event.stopPropagation()"
                              name=""
                              required
                              mask="separator.2"
                              thousandSeparator="."
                              decimalMarker=","
                              prefix=""
                              [allowNegativeNumbers]="true"
                              [clearIfNotMatch]="false"
                              placeholder="0,00"
                              [disabled]="deveDesabilitarAjusteSubFrota(subFleet)"
                            />
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="card-content"
                    *ngIf="isSubFleetExpanded(subFleet.id)"
                  >
                    <!-- Vehicle Details Mat-Table -->
                    <div class="vehicles-section" *ngIf="shouldShowVehicles(subFleet.id)">
                      <h5 class="subsection-title">

                       Veículos
                      </h5>

                      <!-- Search Input for Vehicles -->
                      <div class="search-section" *ngIf="subFleet.vehicles && subFleet.vehicles.length > 0">
                        <mat-form-field appearance="outline" class="search-field">
                          <mat-label>Pesquisar Veículo</mat-label>
                          <input
                            matInput
                            [(ngModel)]="vehicleSearchTerm[subFleet.id]"
                            placeholder="Buscar por placa, código ou modelo..."
                            (click)="$event.stopPropagation()"
                          />
                          <mat-icon matPrefix>search</mat-icon>
                        </mat-form-field>
                      </div>

                      <!-- Skeleton para carregamento inicial de veículos -->
                      <div
                        *ngIf="
                          subFleet.vehicles.length === 0 &&
                          !isLoadingVeiculos(subFleet.id) &&
                          !hasError &&
                          !veiculoEmpty[subFleet.id]
                        "
                        class="skeleton-loading"
                      >
                        <div class="vehicle-table-skeleton">
                          <!-- Header Skeleton -->
                          <div class="skeleton-table-header">
                            <ngx-skeleton-loader
                              count="1"
                              [theme]="{
                                height: '12px',
                                width: '70px',
                                'margin-right': '16px'
                              }"
                            ></ngx-skeleton-loader>
                            <ngx-skeleton-loader
                              count="1"
                              [theme]="{
                                height: '12px',
                                width: '100px',
                                'margin-right': '16px'
                              }"
                            ></ngx-skeleton-loader>
                            <ngx-skeleton-loader
                              count="1"
                              [theme]="{
                                height: '12px',
                                width: '90px',
                                'margin-right': '16px'
                              }"
                            ></ngx-skeleton-loader>
                            <ngx-skeleton-loader
                              count="1"
                              [theme]="{
                                height: '12px',
                                width: '80px',
                                'margin-right': '16px'
                              }"
                            ></ngx-skeleton-loader>
                          </div>
                          <!-- Rows Skeleton -->
                          <div
                            class="skeleton-table-row"
                            *ngFor="let row of [1, 2, 3, 4, 5]"
                          >
                            <ngx-skeleton-loader
                              count="1"
                              [theme]="{
                                height: '10px',
                                width: '60px',
                                'margin-right': '16px'
                              }"
                            ></ngx-skeleton-loader>
                            <ngx-skeleton-loader
                              count="1"
                              [theme]="{
                                height: '10px',
                                width: '70px',
                                'margin-right': '16px'
                              }"
                            ></ngx-skeleton-loader>
                            <ngx-skeleton-loader
                              count="1"
                              [theme]="{
                                height: '10px',
                                width: '80px',
                                'margin-right': '16px'
                              }"
                            ></ngx-skeleton-loader>
                            <ngx-skeleton-loader
                              count="1"
                              [theme]="{
                                height: '10px',
                                width: '65px',
                                'margin-right': '16px'
                              }"
                            ></ngx-skeleton-loader>
                          </div>
                        </div>
                      </div>

                      <!-- Mensagem quando não há veículos -->
                      <div
                        *ngIf="veiculoEmpty[subFleet.id] && subFleet.vehicles.length === 0"
                        class="empty-message"
                      >
                        <mat-icon>info_outline</mat-icon>
                        <span>Não há veículos para exibir.</span>
                      </div>

                      <mat-table
                        [dataSource]="getFilteredVehicles(subFleet)"
                        class="vehicles-table"
                        *ngIf="subFleet.vehicles.length > 0"
                      >
                        <!-- License Plate Column -->
                        <ng-container matColumnDef="licensePlate">
                          <mat-header-cell *matHeaderCellDef
                            >Placa</mat-header-cell
                          >
                          <mat-cell *matCellDef="let vehicle" class="code bold">
                            {{ vehicle.licensePlate }}
                          </mat-cell>
                        </ng-container>
                        <!-- Fleet Code Column -->
                        <ng-container matColumnDef="fleetCode">
                          <mat-header-cell *matHeaderCellDef
                            >Código da Frota</mat-header-cell
                          >
                          <mat-cell
                            *matCellDef="let vehicle"
                            class="code small"
                          >
                            {{ vehicle.fleetCode }}
                          </mat-cell>
                        </ng-container>
                        <!-- Model Column -->
                        <ng-container matColumnDef="model">
                          <mat-header-cell *matHeaderCellDef
                            >Modelo do Veículo</mat-header-cell
                          >
                          <mat-cell *matCellDef="let vehicle">
                            {{ vehicle.model }}
                          </mat-cell>
                        </ng-container>
                        <!-- Last Quota Column (merged with date and value) -->
                        <ng-container matColumnDef="quota">
                          <mat-header-cell *matHeaderCellDef class="header-right"
                            >Última Cota</mat-header-cell
                          >
                          <mat-cell
                            *matCellDef="let vehicle"
                            class="code right"
                          >
                            <div class="quota-cell">
                              <span class="quota-date">{{ vehicle.lastAdjustment }}</span>
                              <span class="quota-value" [ngClass]="getQuotaClass(vehicle.quota)">
                                {{ vehicle.quota }}
                              </span>
                            </div>
                          </mat-cell>
                        </ng-container>
                        <!-- Current Balance Column -->
                        <ng-container matColumnDef="currentBalance">
                          <mat-header-cell *matHeaderCellDef class="header-right"
                            >Saldo Atual</mat-header-cell
                          >
                          <mat-cell
                            *matCellDef="let vehicle"
                            class="code right bold"
                          >
                            {{ getVehicleCurrentBalance(vehicle.licensePlate) }}
                          </mat-cell>
                        </ng-container>
                        <!-- Status Column -->
                        <ng-container matColumnDef="status">
                          <mat-header-cell *matHeaderCellDef
                            >Status</mat-header-cell
                          >
                          <mat-cell *matCellDef="let vehicle">
                            <span
                              class="status-badge"
                              [ngClass]="getStatusClass(vehicle.status)"
                            >
                              {{ vehicle.status }}
                            </span>
                          </mat-cell>
                        </ng-container>
                        <!-- Adjustment Column -->
                        <ng-container matColumnDef="adjustment">
                          <mat-header-cell *matHeaderCellDef
                            >Ajuste</mat-header-cell
                          >
                          <mat-cell *matCellDef="let vehicle">
                            <mat-form-field
                              appearance="outline"
                              class="adjustment-field"
                            >
                              <input
                                matInput
                                [(ngModel)]="
                                  adjustments['vehicle-' + vehicle.licensePlate]
                                "
                                type="text"
                                class=""
                                (ngModelChange)="
                                  onAdjustmentChange(
                                    'vehicle-' + vehicle.licensePlate,
                                    $event
                                  )
                                "
                                (blur)="
                                  onAdjustmentBlur(
                                    'vehicle-' + vehicle.licensePlate,
                                    $any($event.target).value
                                  )
                                "
                                name=""
                                required
                                mask="separator.2"
                                thousandSeparator="."
                                decimalMarker=","
                                prefix=""
                                [allowNegativeNumbers]="true"
                                [clearIfNotMatch]="false"
                                placeholder="0,00"
                                [disabled]="vehicle.dscSituac === 'D' || deveDesabilitarAjusteVeiculo(vehicle)"
                              />
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>
                        <!-- Notes Column -->
                        <ng-container matColumnDef="notes">
                          <mat-header-cell *matHeaderCellDef
                            >Observações</mat-header-cell
                          >
                          <mat-cell *matCellDef="let vehicle">
                            <mat-form-field
                              appearance="outline"
                              class="notes-field"
                            >
                              <input
                                matInput
                                placeholder="Observações"
                                [value]="
                                  notes['vehicle-' + vehicle.licensePlate] || ''
                                "
                                (input)="
                                  onNotesChange(
                                    'vehicle-' + vehicle.licensePlate,
                                    $any($event.target).value
                                  )
                                "
                                [disabled]="vehicle.dscSituac === 'D' || deveDesabilitarAjusteVeiculo(vehicle)"
                              />
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>
                        <mat-header-row
                          *matHeaderRowDef="displayedColumns"
                        ></mat-header-row>
                        <mat-row
                          *matRowDef="let row; columns: displayedColumns"
                          [class.vehicle-disabled]="row.dscSituac === 'D'"
                        ></mat-row>
                      </mat-table>

                      <!-- Botão Carregar Mais Veículos -->
                      <div
                        class="load-more-section"
                        *ngIf="
                          shouldShowLoadMoreVeiculos(subFleet.id) ||
                          isLoadingVeiculos(subFleet.id)
                        "
                      >
                        <button
                          mat-stroked-button
                          *ngIf="shouldShowLoadMoreVeiculos(subFleet.id)"
                          (click)="loadMoreVeiculos(subFleet.id)"
                          class="load-more-button"
                        >
                          <mat-icon>expand_more</mat-icon>
                          Carregar mais veículos
                        </button>

                        <div
                          *ngIf="isLoadingVeiculos(subFleet.id)"
                          class="skeleton-loading"
                        >
                          <div class="vehicle-table-skeleton">
                            <!-- Header Skeleton -->
                            <div class="skeleton-table-header">
                              <ngx-skeleton-loader
                                count="1"
                                [theme]="{
                                  height: '12px',
                                  width: '80px',
                                  'margin-right': '16px'
                                }"
                              ></ngx-skeleton-loader>
                              <ngx-skeleton-loader
                                count="1"
                                [theme]="{
                                  height: '12px',
                                  width: '120px',
                                  'margin-right': '16px'
                                }"
                              ></ngx-skeleton-loader>
                              <ngx-skeleton-loader
                                count="1"
                                [theme]="{
                                  height: '12px',
                                  width: '100px',
                                  'margin-right': '16px'
                                }"
                              ></ngx-skeleton-loader>

                              <ngx-skeleton-loader
                                count="1"
                                [theme]="{ height: '12px', width: '130px' }"
                              ></ngx-skeleton-loader>
                            </div>
                            <!-- Rows Skeleton -->
                            <div
                              class="skeleton-table-row"
                              *ngFor="let row of [1, 2, 3]"
                            >
                              <ngx-skeleton-loader
                                count="1"
                                [theme]="{
                                  height: '10px',
                                  width: '70px',
                                  'margin-right': '16px'
                                }"
                              ></ngx-skeleton-loader>
                              <ngx-skeleton-loader
                                count="1"
                                [theme]="{
                                  height: '10px',
                                  width: '90px',
                                  'margin-right': '16px'
                                }"
                              ></ngx-skeleton-loader>
                              <ngx-skeleton-loader
                                count="1"
                                [theme]="{
                                  height: '10px',
                                  width: '100px',
                                  'margin-right': '16px'
                                }"
                              ></ngx-skeleton-loader>

                              <ngx-skeleton-loader
                                count="1"
                                [theme]="{ height: '24px', width: '140px' }"
                              ></ngx-skeleton-loader>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <!-- Mensagem quando veículos estão ocultos -->
                    <div class="vehicles-hidden-message" *ngIf="!shouldShowVehicles(subFleet.id)">
                      <div class="message-content">
                        <mat-icon class="info-icon">info</mat-icon>
                        <span class="message-text">
                          A listagem de veículos não está disponível para esta subfrota.
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Botão Carregar Mais Subfrotas -->
                <div
                  class="load-more-section"
                  *ngIf="
                    shouldShowLoadMoreSubFrotas(fleet.id) ||
                    isLoadingSubFrotas(fleet.id)
                  "
                >
                  <button
                    mat-stroked-button
                    *ngIf="shouldShowLoadMoreSubFrotas(fleet.id)"
                    (click)="loadMoreSubFrotas(fleet.id)"
                    class="load-more-button"
                  >
                    <mat-icon>expand_more</mat-icon>
                    Carregar mais subfrotas
                  </button>

                  <div
                    *ngIf="isLoadingSubFrotas(fleet.id)"
                    class="skeleton-loading"
                  >
                    <div
                      class="subfleet-skeleton-card"
                      *ngFor="let item of [1, 2, 3]"
                    >
                      <div class="skeleton-card-header">
                        <div class="skeleton-card-header-content">
                          <div class="skeleton-card-info">
                            <ngx-skeleton-loader
                              count="1"
                              appearance="circle"
                              [theme]="{
                                height: '20px',
                                width: '20px',
                                'margin-right': '12px'
                              }"
                            ></ngx-skeleton-loader>
                            <ngx-skeleton-loader
                              count="1"
                              [theme]="{ height: '18px', width: '280px' }"
                            ></ngx-skeleton-loader>
                          </div>
                          <div class="skeleton-card-data">
                            <div class="skeleton-data-item">
                              <ngx-skeleton-loader
                                count="1"
                                [theme]="{
                                  height: '12px',
                                  width: '80px',
                                  'margin-bottom': '4px'
                                }"
                              ></ngx-skeleton-loader>
                              <ngx-skeleton-loader
                                count="1"
                                [theme]="{ height: '14px', width: '90px' }"
                              ></ngx-skeleton-loader>
                            </div>
                            <div class="skeleton-data-item">
                              <ngx-skeleton-loader
                                count="1"
                                [theme]="{
                                  height: '12px',
                                  width: '70px',
                                  'margin-bottom': '4px'
                                }"
                              ></ngx-skeleton-loader>
                              <ngx-skeleton-loader
                                count="1"
                                [theme]="{ height: '14px', width: '95px' }"
                              ></ngx-skeleton-loader>
                            </div>
                            <div class="skeleton-data-item">
                              <ngx-skeleton-loader
                                count="1"
                                [theme]="{
                                  height: '12px',
                                  width: '40px',
                                  'margin-bottom': '4px'
                                }"
                              ></ngx-skeleton-loader>
                              <ngx-skeleton-loader
                                count="1"
                                [theme]="{ height: '14px', width: '110px' }"
                              ></ngx-skeleton-loader>
                            </div>
                            <div class="skeleton-adjustment-item">
                              <ngx-skeleton-loader
                                count="1"
                                [theme]="{
                                  height: '12px',
                                  width: '45px',
                                  'margin-bottom': '4px'
                                }"
                              ></ngx-skeleton-loader>
                              <ngx-skeleton-loader
                                count="1"
                                [theme]="{ height: '40px', width: '120px' }"
                              ></ngx-skeleton-loader>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Botão Avançar -->
  <div
    class="advance-section"
    *ngIf="adjustmentHistory.length > 0 && currentStep === 'adjustments'"
  >
    <div class="advance-container d-flex justify-content-end">
      <button
        mat-raised-button
        color="primary"
        class="advance-button"
        (click)="applyAdjustments()"
      >
        <mat-icon>arrow_forward</mat-icon>
        Avançar
      </button>
    </div>
  </div>
</div>

<!-- Step de Confirmação -->
<div class="confirmation-step" *ngIf="currentStep === 'confirmation'">
  <div class="confirmation-header">
    <div class="header-content">
      <div class="header-title">
        <mat-icon class="header-icon">check_circle</mat-icon>
        <h2>Confirmar Ajustes</h2>
      </div>
      <p class="step-description">Revise os ajustes antes de confirmar</p>
    </div>
    <button mat-button class="back-button" (click)="resetToAdjustments()">
      <mat-icon>arrow_back</mat-icon>
      Voltar
    </button>
  </div>

  <!-- Campo de Observação Geral -->
  <div class="general-observation-section">
    <h3>Observação Geral</h3>
    <mat-form-field appearance="outline" class="general-observation-field">
      <textarea
        matInput
        placeholder="Digite uma observação geral para todos os ajustes..."
        [(ngModel)]="generalObservation"
        rows="3"
        maxlength="500"
      ></textarea>
    </mat-form-field>
    <mat-hint>{{ generalObservation.length || 0 }}/500 caracteres</mat-hint>
  </div>

  <!-- Tabela Detalhada de Ajustes -->
  <div class="adjustments-table-section">
    <h3>Detalhes dos Ajustes</h3>

    <!-- Mensagem quando não há alterações -->
    <div *ngIf="!hasAnyAdjustments()" class="no-changes-message">
      <mat-icon>info</mat-icon>
      <span
        >Nenhuma alteração foi realizada. Não há ajustes para confirmar.</span
      >
    </div>

    <!-- Acordeão das Subfrotas -->
    <div
      class="subfleet-accordion"
      *ngIf="hasAnyAdjustments() && getFleetsWithChanges().length > 0"
    >
      <div
        class="subfleet-card"
        *ngFor="let fleet of getFleetsWithChanges(); let fleetIndex = index"
      >
        <div
          class="subfleet-header"
          (click)="toggleFleetConfirmation(fleet.id)"
        >
          <div class="subfleet-info">
            <mat-icon
              class="expand-icon"
              [class.expanded]="isFleetExpandedConfirmation(fleet.id)"
            >
              {{
                isFleetExpandedConfirmation(fleet.id)
                  ? "expand_less"
                  : "expand_more"
              }}
            </mat-icon>
            <span class="subfleet-title">{{ fleet.description }}</span>
            <span class="subfleet-count"
              >({{ getSubFleetsWithChanges(fleet).length }} subfrotas com
              alterações)</span
            >
          </div>
        </div>

        <!-- Ajuste Direto da Frota -->
        <div class="fleet-direct-adjustment" *ngIf="hasFleetDirectAdjustment(fleet.id)">
          <div class="fleet-adjustment-header">
            <mat-icon class="fleet-icon">business</mat-icon>
            <span class="fleet-adjustment-title">Ajuste Direto na Frota</span>
          </div>
          <div class="fleet-adjustment-details">
            <div class="fleet-adjustment-item">
              <span class="adjustment-label">Valor do Ajuste:</span>
              <span class="adjustment-value" [ngClass]="{'negative': getFleetAdjustment(fleet.id) < 0}">
                {{ getFleetAdjustment(fleet.id).toLocaleString('pt-BR', { minimumFractionDigits: 2 }) }}
              </span>
            </div>
            <div class="fleet-adjustment-item" *ngIf="getFleetNotes(fleet.id)">
              <span class="adjustment-label">Observação:</span>
              <span class="adjustment-notes">{{ getFleetNotes(fleet.id) }}</span>
            </div>
          </div>
        </div>

        <!-- Conteúdo das Subfrotas -->
        <div
          class="subfleet-content"
          *ngIf="isFleetExpandedConfirmation(fleet.id)"
        >
          <div
            class="subfleet-item"
            *ngFor="
              let subFleet of getSubFleetsWithChanges(fleet);
              let subFleetIndex = index
            "
          >
            <div class="subfleet-card-header">
              <div class="subfleet-details">
                <span class="subfleet-code">{{ subFleet.code }}</span>
                <span class="subfleet-description">{{
                  subFleet.description
                }}</span>
                <span class="subfleet-vehicles"
                  >🚗 ({{ subFleet.qtdVehicles }})</span
                >
              </div>

              <!-- Informações da Subfrota -->
              <div class="subfleet-balance-info">
                <div class="balance-item">
                  <span class="balance-label">Saldo Original:</span>
                  <span class="balance-value"
                    >
                    {{
                      getOriginalSubFleetBalance(subFleet.id).toLocaleString(
                        "pt-BR",
                        { minimumFractionDigits: 2 }
                      )
                    }}</span
                  >
                </div>
                <div class="balance-item">
                  <span class="balance-label">Cota:</span>
                  <span class="balance-value"
                    >
                    {{
                      parseCurrencyValue(subFleet.lastQuota).toLocaleString(
                        "pt-BR",
                        { minimumFractionDigits: 2 }
                      )
                    }}</span
                  >
                </div>
                <div class="balance-item">
                  <span class="balance-label">Ajuste Total:</span>
                  <span class="balance-value adjustment"
                    >
                    {{
                      getSubFleetTotalAdjustment(subFleet.id).toLocaleString(
                        "pt-BR",
                        { minimumFractionDigits: 2 }
                      )
                    }}</span
                  >
                </div>
              </div>
            </div>

            <!-- Tabela de Veículos -->
            <div
              class="vehicles-section"
              *ngIf="getVehiclesWithChanges(subFleet).length > 0"
            >
              <h4>Veículos com Alterações</h4>
              <table class="vehicles-table">
                <thead>
                  <tr>
                    <th>Placa</th>
                    <th>Código da Frota</th>
                    <th>Modelo</th>
                    <th>Saldo Atual</th>
                    <th>Status</th>
                    <th>Ajuste</th>
                    <th>Observações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let vehicle of getVehiclesWithChanges(subFleet)">
                    <td>{{ vehicle.licensePlate }}</td>
                    <td>{{ vehicle.fleetCode }}</td>
                    <td>{{ vehicle.model }}</td>
                    <td [class]="getQuotaClass(vehicle.quota)">
                      {{ getVehicleCurrentBalance(vehicle.licensePlate) }}
                    </td>
                    <td>
                      <span
                        class="status-badge"
                        [class]="getStatusClass(vehicle.status)"
                      >
                        {{ vehicle.status }}
                      </span>
                    </td>
                    <td>
                      <span
                        *ngIf="getVehicleAdjustment(vehicle.licensePlate) !== 0"
                        class="adjustment-value"
                        [class.negative]="
                          getVehicleAdjustment(vehicle.licensePlate) < 0
                        "
                      >
                        
                        {{
                          getVehicleAdjustment(
                            vehicle.licensePlate
                          ).toLocaleString("pt-BR", {
                            minimumFractionDigits: 2
                          })
                        }}
                      </span>
                      <span
                        *ngIf="getVehicleAdjustment(vehicle.licensePlate) === 0"
                        class="no-adjustment"
                        >-</span
                      >
                    </td>
                    <td>
                      <span
                        *ngIf="getVehicleNotes(vehicle.licensePlate)"
                        class="notes-text"
                      >
                        {{ getVehicleNotes(vehicle.licensePlate) }}
                      </span>
                      <span
                        *ngIf="!getVehicleNotes(vehicle.licensePlate)"
                        class="no-notes"
                        >-</span
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Botões de Ação -->
  <div class="step-actions">
    <button mat-button class="cancel-button" (click)="resetToAdjustments()">
      <mat-icon>cancel</mat-icon>
      Cancelar
    </button>
    <button
      mat-raised-button
      color="primary"
      class="confirm-button"
      (click)="confirmAdjustments()"
    >
      <mat-icon>send</mat-icon>
      Enviar
    </button>
  </div>
</div>

<!-- Botão Flutuante de Avançar -->
<button
  mat-fab
  class="floating-next-button"
  *ngIf="currentStep === 'adjustments' && hasAnyAdjustments()"
  (click)="goToConfirmation()"
  matTooltip="Avançar para confirmação"
  matTooltipPosition="left"
>
  <mat-icon>arrow_forward</mat-icon>
</button>
